module.exports = __webpack_public_path__ + "img/pr-13.0c081c62.png";